import { render } from "./ViewTransfertMagasin.vue?vue&type=template&id=2e13c6ea&ts=true"
import script from "./ViewTransfertMagasin.vue?vue&type=script&lang=ts"
export * from "./ViewTransfertMagasin.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__